import { Backdrop, CircularProgress, TextField } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import PaymentMethodInputs from '../../shared/PaymentMethodInputs/PaymentMethodInputs';
import { useOrgOptions } from '../../provider/OrganizationOptionsProvider';
import '../../RentalSessions/RentalSessionPopUps/RentalSessionPopUps.css';

function ProductSaleAdminEditPopup({ sale, onClose, onEdit }) {
    const { currency } = useOrgOptions();

    const [isFormEdited, setIsFormEdited] = useState(false);
    const [editForm, setEditForm] = useState({
        cash: parseFloat(sale.paymentCash.$numberDecimal),
        credit: parseFloat(sale.paymentCredit.$numberDecimal),
        message: '',
    });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (
            editForm.cash !== parseFloat(sale.paymentCash.$numberDecimal) ||
            editForm.credit !== parseFloat(sale.paymentCredit.$numberDecimal)
        ) {
            setIsFormEdited(true);
        } else {
            setIsFormEdited(false);
        }
    }, [editForm, sale]);

    const handleNoteChange = useCallback((event) => {
        setEditForm((curState) => ({ ...curState, [event.target.name]: event.target.value }));
    }, []);

    const handlePaymentInputChange = useCallback((values) => {
        setEditForm((curState) => ({ ...curState, ...values }));
    }, []);

    const handleSave = useCallback(async () => {
        setIsLoading(true);
        if (
            await onEdit({
                saleId: sale._id,
                paymentCash: editForm.cash,
                paymentCredit: editForm.credit,
                message: editForm.message,
            })
        ) {
            onClose();
        }
        setIsLoading(false);
    }, [onEdit, onClose, editForm, sale._id]);

    return (
        <>
            <div className="popUp-wrapper">
                <h3 className="sessionEdit-header">Edit Product Sale</h3>
                <div className="sessionEdit-body">
                    <div className="totalPriceSection">
                        <span>Total Price : </span>
                        <span className="endPopUp-priceIndicators">
                            {(editForm.cash + editForm.credit).toFixed(2)}
                            {currency.sign}
                        </span>
                    </div>
                    <PaymentMethodInputs
                        value={{
                            cash: sale.paymentCash.$numberDecimal,
                            credit: sale.paymentCredit.$numberDecimal,
                        }}
                        onInput={handlePaymentInputChange}
                        showChangeCalculator={false}
                        hideFitpass={true}
                    />
                    <div className="sessionEdit-item sessionEdit-note">
                        <TextField
                            id="message"
                            label="Add Note"
                            variant="standard"
                            name="message"
                            value={editForm.message}
                            onChange={handleNoteChange}
                            InputLabelProps={{ shrink: true }}
                            className="sessionEdit-noteIput"
                        />
                    </div>
                </div>
                <div className="sessionPopUp-actions">
                    <button className="popUp-button cancel" onClick={onClose} disabled={isLoading}>
                        Cancel
                    </button>
                    <button
                        onClick={handleSave}
                        disabled={!isFormEdited || !editForm.message || isLoading}
                        className="popUp-button start">
                        {isLoading ? <CircularProgress className="circularProgress" /> : null}
                        Save
                    </button>
                </div>
            </div>
            <Backdrop className="alert-backdrop" open={true} onClick={onClose} />
        </>
    );
}

export default ProductSaleAdminEditPopup;
